"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicRadioModal = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
var _react = _interopRequireWildcard(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _contentDispatch = require("../../framework/components/contentDispatch");
var _FemaGoModal = _interopRequireDefault(require("../../go/components/common/modal/FemaGoModal"));
var _reactRouterDom = require("react-router-dom");
var _lodash = _interopRequireDefault(require("lodash"));
var UTIL_FUNCTIONS = _interopRequireWildcard(require("../../common/utils"));
var _excluded = ["actionOptions", "detailsContent", "id", "title", "size", "className", "defaultValue", "ruleSet", "contentMap", "propsToChild", "validationErrors", "visibleModalPath"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function reducer(state, action) {
  switch (action.type) {
    case 'SELECT':
      return _objectSpread(_objectSpread({}, state), {}, {
        priorAction: state.selectedAction,
        selectedAction: action.value,
        showModal: true
      });
    case 'CONFIRM':
      return _objectSpread(_objectSpread({}, state), {}, {
        showModal: false
      });
    case 'CANCEL':
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedAction: state.priorAction,
        showModal: false
      });
    default:
      throw new Error();
  }
}
var DynamicRadioModal = function DynamicRadioModal(_ref) {
  var actionOptions = _ref.actionOptions,
    detailsContent = _ref.detailsContent,
    id = _ref.id,
    title = _ref.title,
    size = _ref.size,
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    ruleSet = _ref.ruleSet,
    contentMap = _ref.contentMap,
    propsToChild = _ref.propsToChild,
    validationErrors = _ref.validationErrors,
    visibleModalPath = _ref.visibleModalPath,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useReducer = (0, _react.useReducer)(reducer, {
      selectedAction: restProps.data || defaultValue,
      priorAction: '',
      showModal: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var actionDetails = _lodash.default.find(actionOptions, {
    key: state.selectedAction
  });
  var actions = [];
  if (actionOptions.length !== 0) {
    actions = _lodash.default.filter(actionOptions, function (opt) {
      return _lodash.default.isUndefined(opt.ruleFunc) || _lodash.default.isFunction(ruleSet[opt.ruleFunc]) && ruleSet[opt.ruleFunc](restProps);
    });
  }
  var _dispatch = function _dispatch(_ref2) {
    var type = _ref2.type,
      value = _ref2.value;
    dispatch({
      type: type,
      value: value
    });
    if (actionDetails.isModal && visibleModalPath) if (['CONFIRM', 'CANCEL'].includes(type)) {
      restProps.saveEntitySessionData(visibleModalPath, undefined);
    } else if (type === 'SELECT') {
      restProps.saveEntitySessionData(visibleModalPath, value);
    }
  };
  var renderSelectedAction = function renderSelectedAction() {
    if (state.selectedAction === state.priorAction) {
      return null;
    }
    var actionOptionDetails = _lodash.default.get(detailsContent, state.selectedAction);
    if (actionOptionDetails) {
      if (actionDetails.isModal) {
        return renderActionDetailsWithModal(actionOptionDetails);
      } else {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
          to: actionOptionDetails[0].url
        });
      }
    }
  };
  var cancelModal = function cancelModal(functionName) {
    _dispatch({
      type: 'CANCEL'
    });
    functionName && UTIL_FUNCTIONS[functionName]();
  };
  var confirmModal = function confirmModal(e, msg) {
    _dispatch({
      type: 'CONFIRM'
    });
    if (restProps.entityDataPath !== undefined) {
      restProps.saveEntityData(restProps.entityDataPath, restProps.entityType, state.selectedAction, restProps.validationId || restProps.entityDataPath);
    } else {
      restProps.saveData(restProps.dataPath, state.selectedAction);
    }
    if (msg) restProps.addMessage(msg);
  };
  var renderActionDetailsWithModal = function renderActionDetailsWithModal(actionOptionDetails) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
      title: actionDetails.modalTitle,
      open: state.showModal,
      size: size,
      buttonText: actionDetails.confirmText || 'Confirm',
      confirmAction: function confirmAction(e) {
        return confirmModal(e, actionDetails.successMessage);
      },
      cancelAction: function cancelAction() {
        cancelModal(actionDetails.cancelFunction);
      },
      readOnly: false,
      type: actionDetails.confirmType,
      disableButton: actionDetails.validate && (validationErrors || []).some(function (v) {
        return !v.isValid;
      })
    }, renderActionDetails(actionOptionDetails)));
  };
  var renderActionDetails = function renderActionDetails(actionOptionDetails) {
    var additionalProps = {};
    if (propsToChild) {
      _lodash.default.each(propsToChild, function (value, key) {
        additionalProps[key] = _lodash.default.get(restProps, value, value);
      });
    }
    return _lodash.default.map(actionOptionDetails, function (details, index) {
      var childProps = _lodash.default.merge({}, details, _objectSpread({}, additionalProps), {
        cancelModal: cancelModal,
        confirmModal: confirmModal
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_contentDispatch.ContentDispatch, {
        contentMap: contentMap,
        config: childProps,
        key: _lodash.default.get(details, 'id', index)
      }));
    });
  };
  var handleRadioClick = function handleRadioClick(value) {
    return function () {
      _dispatch({
        type: 'SELECT',
        value: value
      });
    };
  };
  var renderRadioGroup = function renderRadioGroup() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className ? className : ''
    }, title && /*#__PURE__*/_react.default.createElement("p", null, title), _lodash.default.map(actions, function (option) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: option.key,
        style: {
          display: 'inline-block',
          marginRight: '20px'
        }
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Radio, {
        id: option.id,
        label: option.label,
        value: option.value,
        checked: state.selectedAction === option.value,
        onClick: handleRadioClick(option.value)
      }));
    }));
  };
  return actions.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderRadioGroup(), state.showModal && renderSelectedAction()) : null;
};
exports.DynamicRadioModal = DynamicRadioModal;